<template>

    <div>
      <b-modal id="modal-evento" ref="my-modal-evento" :ok-title="btnGrabarEvento" cancel-title="Cerrar" centered
               size="lg" :title="titleModalEvento" @show="resetModalEvento" @hidden="resetModalEvento"
               @ok="handleOkEvento">

        <validation-observer ref="simpleRulesEvento">
          <b-form>
            <b-row>
              <b-col md="6" xl="4">
                <b-form-group>
                  <label>Tipo Evento</label>
                  <validation-provider #default="{ errors }" rules="required" name="Tipo Evento">
                    <b-form-select v-model="selectedTipoEvento"
                                   :state="errors.length > 0 ? false : null" :options="optionsTipoEvento"
                                   v-on:change="mostrarInvolucradosTipoEvento()" required />
                    <small class="text-danger" v-if="errors[0]">El campo Tipo Evento es
                      obligatorio</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="12" xl="12">
                <b-form-group>
                  <label>Involucrados</label>
                  <validation-provider #default="{ errors }" rules="required" name="Involucrados">
                    <v-select v-model="selectedInvolucradoEvento"
                              :state="errors.length > 0 ? false : null"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="nombre_involucrado"
                              :options="optionInvolucradoEvento" multiple />
                    <small class="text-danger" v-if="errors[0]">El campo Involucrados es
                      obligatorio</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <template v-if="this.selectedInvolucradoEvento.length !== 0">
                <b-col md="12" xl="12">
                  <b-form-group>
                    <label>Sanciones de Involucrados</label>

                    <b-list-group>
                      <b-list-group-item class="d-flex justify-content-between align-items-center"
                                         v-for="selectedInvEvento in this.selectedInvolucradoEvento"
                                         v-bind:data="selectedInvEvento"
                                         v-bind:key="selectedInvEvento.id">
                        <span>{{ selectedInvEvento.nombre_involucrado }}</span>
                        <b-badge variant="primary" pill class="badge-round">
                          {{ mostrarDescripcionTipoSancion(selectedInvEvento.ultimo_tipo_sancion, selectedInvEvento.dni_involucrado) }}, {{
                            selectedInvEvento.cant_dias
                          }} Día(s)
                        </b-badge>
                      </b-list-group-item>
                    </b-list-group>
                  </b-form-group>

                </b-col>
              </template>

              <template v-if="this.selectedTipoEvento === 5">

                <b-col md="5">
                  <b-form-group>
                    <label>Tipo de Sanción</label>
                    <validation-provider #default="{ errors }" rules="required" name="Tipo de Sanción">
                      <b-form-select v-model="selectedTipoSancion"
                                     :state="errors.length > 0 ? false : null" :options="optionsTipoSancion"
                                     v-on:change="verificarDiasSancion()" />
                      <small class="text-danger" v-if="errors[0]">El campo Tipo de Sanción es
                        obligatorio</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="3">
                  <b-form-group>
                    <label>Cant. Días</label>
                    <validation-provider #default="{ errors }" rules="required|integer"
                                         name="Cant. Días">
                      <b-form-input v-model="cant_dias" :disabled="disabled_cant_dias"
                                    :state="errors.length > 0 ? false : null" placeholder="Cant. Días"
                                    v-on:keyup="calcularFechasSancionCierre()" />
                      <small class="text-danger" v-if="errors[0]">El campo Cant. Días es
                        obligatorio y debe ser un número entero</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col md="4" v-if="this.fechassancioncierre.length !== 0">
                  <label>Fechas de Generadas</label>
                  <template v-for="item in this.fechassancioncierre">
                    <b-input-group class="mb-1">
                      <b-form-input type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                    show-decade-nav v-model.lazy="item.fecha_sancion" />
                      <b-input-group-append>
                        <b-form-datepicker show-decade-nav v-model.lazy="item.fecha_sancion"
                                           button-only right locale="es-ES" size="sm" />
                      </b-input-group-append>
                    </b-input-group>
                  </template>
                </b-col>

              </template>

              <b-col md="12">
                <b-form-group>
                  <label>Descripción</label>
                  <b-form-input v-model="descripcionInvolucradoEvento" placeholder="Descripción" />
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-form-group>
                  <label>Evidencia</label>
                  <validation-provider #default="{ errors }" rules="" name="Evidencia">
                    <b-form-file v-model="filesEv" :state="errors.length > 0 ? false : null"
                                 accept=".jpg, .jpeg, .png, .mp3, .wav, .3gp, .mov, .avi, .mp4, .flv, .docx, .pdf, .xlsx, .pptx"
                                 placeholder="Ningún archivo elegido" browse-text="Archivos" multiple />
                    <small class="text-danger" v-if="errors[0]">El campo Evidencia es
                      obligatorio</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-form-group>
                  <label>Descargo</label>
                  <validation-provider #default="{ errors }" rules="" name="Descargo">
                    <b-form-file v-model="filesDe" :state="errors.length > 0 ? false : null"
                                 accept=".jpg, .jpeg, .png, .mp3, .wav, .3gp, .mov, .avi, .mp4, .flv, .docx, .pdf, .xlsx, .pptx"
                                 placeholder="Ningún archivo elegido" browse-text="Archivos" multiple />
                    <small class="text-danger" v-if="errors[0]">El campo Descargo es
                      obligatorio</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

            </b-row>

          </b-form>
        </validation-observer>
      </b-modal>

      <b-modal id="modal-editar-detalle-falta" ref="my-modal-editar-detalle-falta" :ok-title="btnEditarDetalleFalta"
               cancel-title="Cerrar" centered size="lg" :title="titleModalEditarDetalleFalta"
               @show="resetModalEditarDetalleFalta" @hidden="resetModalEditarDetalleFalta"
               @ok="handleOkEditarDetalleFalta">

        <validation-observer ref="simpleRulesEditarDetalleFalta">
          <b-form>

            <b-form-group>
              <label>Detalle de la falta</label>
              <validation-provider #default="{ errors }" rules="required" name="Detalle de la falta">
                <b-form-input v-model="descripcionEditarDetalleFalta" :state="errors.length > 0 ? false : null" placeholder="Detalle de la falta" />
                <small class="text-danger" v-if="errors[0]">El campo Detalle de la falta es
                  obligatorio</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <label>Observación</label>
              <validation-provider #default="{ errors }" rules="required" name="Observación">
                <b-form-input v-model="observacioninvolucrado" :state="errors.length > 0 ? false : null" placeholder="Observación" />
                <small class="text-danger" v-if="errors[0]">El campo Observación es
                  obligatorio</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <label>¿FIRMÓ PAPELETA?</label>
              <validation-provider #default="{ errors }" rules="required" name="¿FIRMÓ PAPELETA?">
                <b-form-select v-model="selectedFirmoPapeleta"
                               :state="errors.length > 0 ? false : null"
                               :options="optionsFirmoPapeleta" />
                <small class="text-danger" v-if="errors[0]">El campo ¿FIRMÓ PAPELETA? es
                  obligatorio</small>
              </validation-provider>
            </b-form-group>

          </b-form>
        </validation-observer>
      </b-modal>

      <b-modal id="modal-subir-archivo-historial-evento" ref="my-modal-subir-archivo-historial-evento"
               :ok-title="btnAddArchivosHistorialEvento" cancel-title="Cerrar" centered size="lg"
               :title="titleModalAddArchivosHistorialEvento" @show="resetModalAddArchivosHistorialEvento"
               @hidden="resetModalAddArchivosHistorialEvento" @ok="handleOkAddArchivosHistorialEvento">
        <validation-observer ref="simpleRulesAddArchivosHistorialEvento">
          <form ref="formAddArchivosHistorialEvento"
                @submit.stop.prevent="handleSubmitAddArchivosHistorialEvento">

            <b-col md="12">
              <b-form-group>
                <label>Evidencia</label>
                <validation-provider #default="{ errors }" rules="" name="Evidencia">
                  <b-form-file v-model="filesEvAdd" :state="errors.length > 0 ? false : null"
                               accept=".jpg, .jpeg, .png, .mp3, .wav, .3gp, .mov, .avi, .mp4, .flv, .docx, .pdf, .xlsx, .pptx"
                               placeholder="Ningún archivo elegido" browse-text="Archivos" multiple />
                  <small class="text-danger" v-if="errors[0]">El campo Evidencia es
                    obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group>
                <label>Descargo</label>
                <validation-provider #default="{ errors }" rules="" name="Descargo">
                  <b-form-file v-model="filesDeAdd" :state="errors.length > 0 ? false : null"
                               accept=".jpg, .jpeg, .png, .mp3, .wav, .3gp, .mov, .avi, .mp4, .flv, .docx, .pdf, .xlsx, .pptx"
                               placeholder="Ningún archivo elegido" browse-text="Archivos" multiple />
                  <small class="text-danger" v-if="errors[0]">El campo Descargo es
                    obligatorio</small>
                </validation-provider>
              </b-form-group>
            </b-col>


          </form>
        </validation-observer>
      </b-modal>

      <div class="row">
        <div class="col-md-11 co-11">&nbsp;</div>
        <div class="col-md-1 co-1">
          <feather-icon icon="ArrowLeftIcon" height="20" width="20" class="mr-1 mb-2  cursor-pointer feather feather-more-vertical"
            v-b-tooltip.hover.right="'Atras'" v-on:click="retornarVista()"></feather-icon>
        </div>
      </div>

      <div class="row">
        <div class="col-md-8 co-8">
          <b-card>
            <b-tabs>

              <b-tab title="Detalle" active v-on:click="iniciarFunciones()">
                <b-card class="card shadow-none bg-transparent border-secondary"
                        v-for="matriz_involucrado in matriz_involucrados"
                        v-bind:data="matriz_involucrado"
                        v-bind:key="matriz_involucrado.id"
                >
                  <div class="card-header">
                    <h4 class="card-title font-weight-bolder">
                      {{ zeroFill(matriz_involucrado.involucrado_id, 5) }} | {{
                        matriz_involucrado.nombre_involucrado
                      }}</h4>
                    <feather-icon v-if="$can('update', 'Sanciones MD')" icon="EditIcon" height="70" width="35"
                                  class="mr-1 cursor-pointer feather feather-more-vertical"
                                  v-b-tooltip.hover.right="'Editar Detalle de Falta'"
                                  v-on:click="mostrarPantallaEditarDetalleFalta(matriz_involucrado.involucrado_id, matriz_involucrado.descripcion, matriz_involucrado.ultimo_estado_sancion_id, matriz_involucrado.ultimo_tipo_sancion_id, matriz_involucrado.observacion_involucrado, matriz_involucrado.firmo_papeleta_involucrado)" />
                  </div>

                  <b-card class="border-left-success border-left-3">
                    <div class="card-header">
                      <h4 class="card-title font-weight-bolder">LUGAR DE FALTA</h4>
                    </div>

                    <div class="row">
                      <div class="col-md-6 co-6 row">
                        <div class="col-md-5 co-5">
                          <h5 class="font-weight-bolder">Fecha Registro: </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.fecha_creacion }}</h5>
                        </div>
                        <div class="col-md-5 co-5">
                          <h5 class="font-weight-bolder">Sociedad: </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.empresa }}</h5>
                        </div>
                        <div class="col-md-5 co-5">
                          <h5 class="font-weight-bolder">Evaluador: </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.nombre_evaluador }}</h5>
                        </div>
                      </div>
                      <div class="col-md-6 co-6 row">
                        <div class="col-md-3 co-3">
                          <h5 class="font-weight-bolder">Lugar: </h5>
                        </div>
                        <div class="col-md-9 co-9">
                          <h5 v-if="matriz_involucrado.etapa != null">{{
                              matriz_involucrado.cultivo + " | " + matriz_involucrado.fundo + " | " + matriz_involucrado.lugar + " | " + matriz_involucrado.etapa + " | " + matriz_involucrado.campo }}</h5>
                          <h5 v-else>{{ matriz_involucrado.cultivo + " | " +
                          matriz_involucrado.fundo + " | " + matriz_involucrado.lugar
                            }}</h5>
                        </div>
                      </div>

                    </div>
                  </b-card>

                  <b-card class="border-left-success border-left-3">
                    <div class="card-header">
                      <h4 class="card-title font-weight-bolder">GESTION HUMANA</h4>
                    </div>

                    <div class="row">
                      <div class="col-md-12 co-12 row">
                        <div class="col-md-4 co-5">
                          <h5 class="font-weight-bolder">Personal RRLL a Cargo (Evaluador): </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.nombre_evaluador }}</h5>
                        </div>
                        <div class="col-md-4 co-5">
                          <h5 class="font-weight-bolder">Acción Correctiva: </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.descripcion_tipo_sancion }}, {{
                              matriz_involucrado.cant_dias
                            }} días</h5>
                        </div>
                        <div class="col-md-4 co-5">
                          <h5 class="font-weight-bolder">Detalle de la Falta Cometida: </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.descripcion }}</h5>
                        </div>
                        <div class="col-md-4 co-5">
                          <h5 class="font-weight-bolder">Observación: </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.observacion_involucrado }}</h5>
                        </div>
                        <div class="col-md-4 co-5">
                          <h5 class="font-weight-bolder">N° Articulo: </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.nro_articulo }}</h5>
                        </div>
                        <div class="col-md-4 co-5">
                          <h5 class="font-weight-bolder">Articulo: </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.articulo }}</h5>
                        </div>
                        <div class="col-md-4 co-5">
                          <h5 class="font-weight-bolder">N° Inciso: </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.nro_inciso }}</h5>
                        </div>
                        <div class="col-md-4 co-5">
                          <h5 class="font-weight-bolder">Inciso: </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.inciso }}</h5>
                        </div>
                        <div class="col-md-4 co-5">
                          <h5 class="font-weight-bolder">Medios Probatorios: </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.medios_probatorios }}</h5>
                        </div>
                        <div class="col-md-4 co-5">
                          <h5 class="font-weight-bolder">Observación: </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.observacion }}</h5>
                        </div>
                        <div class="col-md-4 co-5">
                          <h5 class="font-weight-bolder">Responsable: </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.responsable }}</h5>
                        </div>
                        <div class="col-md-4 co-5">
                          <h5 class="font-weight-bolder">Supuesto: </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.supuesto }}</h5>
                        </div>
                        <div class="col-md-4 co-5">
                          <h5 class="font-weight-bolder">¿FIRMÓ PAPELETA?: </h5>
                        </div>
                        <div class="col-md-7 co-7">
                          <h5>{{ matriz_involucrado.firmo_papeleta_involucrado }}</h5>
                        </div>
                      </div>
                    </div>
                  </b-card>

                  <b-card class="border-left-success border-left-3"
                          v-for="involucrado in sancion.involucrados"
                          v-bind:data="involucrado"
                          v-bind:key="involucrado.id"
                          v-if="involucrado.dni_involucrado === matriz_involucrado.dni_involucrado">
                    <template v-for="historial_evento in involucrado.historial_eventos">

                      <div class="card-header">
                        <h4 class="card-title font-weight-bolder" v-for="tip_ev in tipoEvento"
                            v-if="tip_ev.id === historial_evento.estado_sancion">{{
                            tip_ev.descripcion
                          }}</h4>

                        <feather-icon icon="UploadCloudIcon" height="70" width="35"
                                      class="mr-1 cursor-pointer feather feather-more-vertical"
                                      v-b-tooltip.hover.right="'Subir Archivos'"
                                      v-on:click="mostrarPantallaAgregarArchivo(historial_evento.id)" />
                      </div>

                      <div class="row" v-if="historial_evento.archivos.length !== 0">
                        <div class="col-md-12 co-12 row" v-for="archivo in historial_evento.archivos" v-if="archivo.tipo_registro === 'EVIDENCIA'">
                          <div class="col-md-4 co-5">
                            <h5 class="">{{ archivo.tipo_registro }}: </h5>
                          </div>
                          <div class="col-md-7 co-7 font-weight-bolder" style="color: #104997;">
                            <template>
                              <a :href="archivo.file" target="_blank">
                                <feather-icon icon="DownloadIcon" />
                                <span> Descargar</span>
                              </a>
                            </template>
                          </div>
                        </div>

                        <div class="col-md-12 co-12 row"
                             v-for="archivo in historial_evento.archivos"
                             v-if="archivo.tipo_registro === 'DESCARGO'">
                          <div class="col-md-4 co-5">
                            <h5 class="">{{ archivo.tipo_registro }}: </h5>
                          </div>
                          <div class="col-md-7 co-7 font-weight-bolder" style="color: #104997;">
                            <template>
                              <a :href="archivo.file" target="_blank">
                                <feather-icon icon="DownloadIcon" />
                                <span> Descargar</span>
                              </a>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div class="row" v-else>
                        <div class="col-md-12 co-12 row">
                          <div class="col-md-4 co-5">
                            <h5 class="">Sin archivos</h5>
                          </div>
                        </div>
                      </div>

                    </template>
                  </b-card>

                  <!-- <div class="row"
                       v-if="matriz_involucrado.ultimo_estado_sancion_id === 5 && matriz_involucrado.sancionado === 'SI'">
                    <div class="col-md-10">
                      <app-collapse>
                        <app-collapse-item title="Memorándum V1">
                          <div v-bind:id="'testHtml' + matriz_involucrado.dni_involucrado"
                               style="width:595px; font-size: 10px; color: #000; padding: 28px;">
                            <div class="centrado" style="font-weight: bold;">
                              <b-img :src="url_logo" height="auto" width="150"
                                     class="mr-1 cursor-pointer feather feather-more-vertical" />
                              <p class="centrado"
                                 style="font-weight: bold; font-size: 15px; text-transform: uppercase;">
                                MEMORANDUM DE
                                {{ matriz_involucrado.descripcion_tipo_sancion }}</p>
                            </div>

                            <br />
                            <br />
                            <br />
                            <br />

                            <table style="width:540px;">
                              <tr>
                                <td>
                                  <div class="left">
                                    {{ fecha_actual_formato_letra_pdf }}
                                  </div>
                                </td>

                                <td>
                                  <div class="right">
                                    Código de Sanción:
                                    {{ zeroFill(matriz_involucrado.involucrado_id, 5) }}
                                  </div>
                                </td>
                              </tr>
                            </table>

                            <br />
                            <br />

                            <div class="left">
                              DNI: {{ matriz_involucrado.dni_involucrado }}
                            </div>
                            <div class="left">
                              Nombre y Apellidos: {{ matriz_involucrado.nombre_involucrado }}
                            </div>
                            <div class="left">
                              Presente.-
                            </div>
                            <br />
                            <br />
                            <div class="justify">
                              Por medio de la presente, le comunicamos que usted incumplió el
                              artículo {{ matriz_involucrado.nro_articulo }} de
                              nuestro
                              Reglamento Interno de Trabajo, el cual indica en su inciso
                              {{ matriz_involucrado.nro_inciso }};
                              {{ matriz_involucrado.inciso }}, De
                              acuerdo
                              con el reporte de fecha {{ fecha_creacion_formato_letra }},
                              emitido por
                              {{ matriz_involucrado.nombre_evaluador }}, en cual usted estuvo
                              presente; en base a ello se determinó que usted incurrió en la
                              falta referida a:
                              {{ matriz_involucrado.descripcion }}.
                              Debido a la gravedad de lo sucedido según reglamento hemos
                              decidido aplicar la medida
                              disciplinaria de
                              {{ matriz_involucrado.descripcion_tipo_sancion }}, dicha medida
                              disciplinaria tiene como
                              finalidad que usted analice sus
                              incumplimientos y situaciones como las descritas, no vuelvan a
                              suceder.
                            </div>
                            <br />
                            <br />
                            <br />
                            <div class="left">
                              Atentamente,
                            </div>
                            <br />
                            <br />
                            <br />
                            <div class="left">
                              <b-img :src="url_firma" height="auto" width="150"
                                     class="mr-1 cursor-pointer feather feather-more-vertical" />
                            </div>

                          </div>
                        </app-collapse-item>
                      </app-collapse>
                    </div>
                    <div class="col-md-2">

                      <feather-icon icon="DownloadIcon" height="70" width="35"
                                    class="mr-1 cursor-pointer feather feather-more-vertical"
                                    v-b-tooltip.hover.right="'Descargar'"
                                    v-on:click="generarMemorandum(matriz_involucrado.dni_involucrado, matriz_involucrado.fecha_creacion)" />
                    </div>
                  </div> -->

                  <div class="row"
                       v-if="matriz_involucrado.ultimo_estado_sancion_id === 5 && matriz_involucrado.sancionado === 'SI'">
                    <div class="col-md-10">
                      <app-collapse>
                        <app-collapse-item title="Memorándum V2">
                          <div v-bind:id="'testHtmlV2' + matriz_involucrado.dni_involucrado"
                               style="width:595px; font-size: 10px; color: #000; padding: 28px;">
                            <div class="centrado" style="font-weight: bold;">
                              <b-img :src="url_logo" height="auto" width="50" class="mr-1"
                                     style="float:left; vertical-align: middle; padding: 5px;" />
                              <p style="font-weight: bold; font-size: 10px; text-transform: uppercase; display: inline-block;
                                                          vertical-align: top;">PAPELETA DE SANCIÓN LABORAL</p>
                            </div>

                            <br />

                            <table class="textopequenio"
                                   style="width:540px; overflow-wrap: break-word;" border="1"
                                   cellspacing="0" cellpadding="5">
                              <tr>
                                <th rowspan="3" width='100' nowrap>JEFE y/o SUPERVISOR
                                  <br /> INMEDIATO QUE REPORTA
                                </th>
                              </tr>
                              <tr style="">
                                <td width='120' nowrap>Nombre</td>
                                <td>{{ matriz_involucrado.nombre_reporta_incidente }}</td>
                              </tr>
                              <tr>
                                <td>Puesto</td>
                                <td>{{ matriz_involucrado.nombre_cargo_reporta_incidente }}
                                </td>
                              </tr>
                            </table>

                            <br />

                            <table class="textopequenio" style="width:540px;" border="1"
                                   cellspacing="10" cellpadding="10">
                              <tr>
                                <th rowspan="5" width='140' nowrap>TRABAJADOR <br />
                                  SANCIONADO</th>
                              </tr>
                              <tr style="">
                                <td width='120' nowrap>Nombre <br /> completo</td>
                                <td>{{ matriz_involucrado.nombre_involucrado }}</td>
                              </tr>
                              <tr>
                                <td width='120' nowrap>Puesto</td>
                                <td>{{ matriz_involucrado.nombre_cargo_involucrado }}</td>
                              </tr>
                              <tr>
                                <td width='120' nowrap>DNI</td>
                                <td>{{ matriz_involucrado.dni_involucrado }}</td>
                              </tr>
                              <tr>
                                <td width='120' nowrap>Área</td>
                                <td>{{ matriz_involucrado.area_involucrado }}</td>
                              </tr>
                            </table>

                            <br />

                            <table class="textopequenio" style="width:540px;" border="1"
                                   cellspacing="0" cellpadding="5">
                              <tr>
                                <th rowspan="3" width='140' nowrap>DESCRIPCIÓN DE <br /> LA
                                  FALTA</th>
                              </tr>
                              <tr style="">
                                <td width='120' nowrap>Fecha(s) de <br /> Ocurrencia</td>
                                <td>{{ format_date(matriz_involucrado.fecha_creacion) }}</td>
                              </tr>
                              <tr>
                                <td width='120' nowrap>Descripción detallada <br /> de la
                                  Falta </td>
                                <td style="text-align: justify;">{{
                                    matriz_involucrado.descripcion_sub_categoria
                                  }}</td>
                              </tr>
                            </table>

                            <br />

                            <table class="textopequenio" style="width:540px;" border="1"
                                   cellspacing="0" cellpadding="5">
                              <tr>
                                <th rowspan="3" width='140' nowrap>NORMA, DIRECTIVA <br /> O
                                  PROTOCOLO <br /> INCUMPLIDO</th>
                              </tr>
                              <tr style="">
                                <td width='120' nowrap>Nombre</td>
                                <td>Reglamento Interno de Trabajo</td>
                              </tr>
                              <tr>
                                <td width='120' nowrap>N° de Normativa</td>
                                <td style="text-align: justify;">Art. N° {{
                                    matriz_involucrado.nro_articulo
                                  }}, Inciso
                                  {{ matriz_involucrado.nro_inciso }}:
                                  {{ matriz_involucrado.supuesto }}</td>
                              </tr>
                            </table>

                            <br />

                            <table class="textopequenio" style="width:540px;" border="1"
                                   cellspacing="0" cellpadding="5">
                              <tr>
                                <th rowspan="6" width='140' nowrap>SANCIÓN A APLICAR </th>
                              </tr>
                              <tr style="">
                                <td colspan="2">Tipo de sanción </td>
                                <td>{{ matriz_involucrado.descripcion_tipo_sancion }}</td>
                              </tr>
                              <tr>
                                <td colspan="2">(*) Días de Suspensión </td>
                                <td>{{ matriz_involucrado.cant_dias }}</td>
                              </tr>
                              <tr v-for="involucrado in sancion.involucrados" v-if="involucrado.dni_involucrado === matriz_involucrado.dni_involucrado && involucrado.fechas_sancion.length !== 0">
                                <td rowspan="2" colspan="1" width='120' nowrap>(*) Periodo
                                  de <br /> Suspensión</td>
                                <td rowspan="2" colspan="1" width='50' nowrap>
                                  <template >
                                    Fecha de Ejecución
                                  </template>
                                </td>
                                <td rowspan="2" colspan="1">
                                  <template v-for="involucrado in sancion.involucrados">

                                    <template v-if="involucrado.dni_involucrado === matriz_involucrado.dni_involucrado && involucrado.fechas_sancion.length !== 0 && involucrado.estado === '1'">

                                      <!--<template v-if="fechasancion.estado !== '111'">
                                        {{ format_date(fechasancion.fecha_sancion) }}
                                        <template v-if="Number(fechasancion.nro_dia) !== involucrado.fechas_sancion.length - 1">,</template>
                                      </template>-->
                                      {{ mostrar_fechas(involucrado.fechas_sancion) }}


                                    </template>

                                    <!--<template v-if="involucrado.dni_involucrado === matriz_involucrado.dni_involucrado && involucrado.fechas_sancion.length === 0">
                                        {{ format_date(matriz_involucrado.fecha_creacion) }}
                                    </template>-->
                                  </template>
                                </td>
                              </tr>
                            </table>
                            <table class="textopequenioV1" style="width:540px;">
                              <tr>
                                <td>
                                  <div class="left">
                                    (*) De no estar de acuerdo con la sanción recibida,
                                    Usted podrá presentar sus descargos en la oficina de
                                    Gestión Humana ubicada en su respectiva sede.</div>
                                </td>
                              </tr>
                            </table>

                            <br />

                            <div class="centradosubrayado textopequenio">
                              FIRMAS Y VALIDACIONES
                            </div>
                            <br />
                            <table class="textopequenio" style="width:540px;">
                              <tr>
                                <th rowspan="6" width='200' nowrap>

                                  VB° Gestión Humana

                                </th>

                                <td>
                                  <b-img :src="url_firma" height="auto" width="80"
                                         class="mr-1 cursor-pointer feather feather-more-vertical" />
                                </td>
                                <td></td>
                                <td> </td>
                              </tr>
                            </table>
                            <br />
                            <br />
                            <table class="textopequenio" style="width:540px;">
                              <tr>
                                <td>

                                </td>

                                <td>
                                  <div class="centrado">

                                  </div>
                                </td>

                                <td>

                                </td>

                                <td>

                                </td>
                              </tr>
                              <tr>
                                <td width='160' nowrap>
                                  <div class="left" style="font-weight: bold;">

                                  </div>
                                </td>
                                <td>
                                  <div class="centrado">
                                    {{ matriz_involucrado.nombre_involucrado }}
                                  </div>
                                </td>
                                <td>
                                  <div class="right" style="font-weight: bold;">
                                    Fecha
                                  </div>
                                </td>
                                <td>
                                  <div class="right">
                                    {{ fechaEspañol(matriz_involucrado.fecha_creacion) }}
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>

                                </td>
                                <td>
                                  <div class="centrado">
                                    {{ matriz_involucrado.dni_involucrado }}
                                  </div>
                                </td>
                                <td>
                                </td>
                                <td>

                                </td>
                              </tr>
                            </table>

                          </div>
                        </app-collapse-item>
                      </app-collapse>
                    </div>
                    <div class="col-md-2">
                      <feather-icon icon="DownloadIcon" height="70" width="35"
                                    class="mr-1 cursor-pointer feather feather-more-vertical"
                                    v-b-tooltip.hover.right="'Descargar'"
                                    v-on:click="generarMemorandumV2(matriz_involucrado.dni_involucrado, matriz_involucrado.fecha_creacion)" />
                    </div>
                  </div>

                </b-card>
              </b-tab>

              <b-tab v-if="$can('update', 'Sanciones MD')" title="Gestionar Sanción">
                <div class="row">

                  <div class="col-md-12 co-12">
                    <b-card>
                      <div class="card-header">
                        <h4 class="card-title">HISTORIAL DE EVENTOS</h4>
                        <b-img
                            :src="require('@/assets/images/medidas_disciplinarias/plus-square.svg')"
                            height="auto" width="35"
                            class="mr-1 cursor-pointer feather feather-more-vertical"
                            v-b-tooltip.hover.right="'Nuevo Evento'"
                            v-on:click="mostrarPantallaNuevoEvento()" />
                      </div>
                      <template v-for="involucrado in sancion.involucrados">

                        <app-collapse>
                          <app-collapse-item :title="involucrado.nombre_involucrado">

                            <app-timeline>

                              <app-timeline-item :variant="mostrarColorEstadoSancion(historial_evento.estado_sancion)"
                                                 v-for="historial_evento in involucrado.historial_eventos"
                                                 v-bind:data="historial_evento"
                                                 v-bind:key="historial_evento.id">


                                <div
                                    class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                                  <h6>{{
                                      mostrarDescripcionEstadoSancion(historial_evento.estado_sancion)
                                    }}
                                  </h6>
                                  <small class="text-muted">{{
                                      format_date_FYH(historial_evento.fecha_creacion)
                                    }}</small>
                                </div>
                                <p>{{ historial_evento.descripcion }}</p>

                              </app-timeline-item>

                            </app-timeline>
                          </app-collapse-item>
                        </app-collapse>

                      </template>

                    </b-card>
                  </div>

                </div>



              </b-tab>

            </b-tabs>
          </b-card>

        </div>
        <div class="col-md-4 co-4">
          <b-card>
            <h4 class="font-weight-bolder">INVOLUCRADOS</h4>
          </b-card>

          <b-card :title="involucrado.nombre_involucrado" class="border-left-success border-left-3"
                  v-for="involucrado in sancion.involucrados"
                  v-bind:data="involucrado"
                  v-bind:key="involucrado.id">
            <div class="row">
              <div class="col-md-12 co-12 row">
                <div class="col-md-7 co-7">
                  <h5 class="font-weight-bolder">Puesto: </h5>
                </div>
                <div class="col-md-5 co-5">
                  <h5>{{ involucrado.nombre_cargo_involucrado }}</h5>
                </div>
              </div>
              <div class="col-md-12 co-12 row">
                <div class="col-md-7 co-7">
                  <h5 class="font-weight-bolder">Área: </h5>
                </div>
                <div class="col-md-5 co-5">
                  <h5>{{ involucrado.area_involucrado }}</h5>
                </div>
              </div>
              <!--<div class="col-md-12 co-12 row">
                  <div class="col-md-7 co-7">
                      <h5 class="font-weight-bolder">Estado: </h5>
                  </div>
                  <div class="col-md-5 co-5">
                      <h5>{{ involucrado.estado }}</h5>
                  </div>
              </div>-->
            </div>
          </b-card>


        </div>

      </div>


    </div>

  </template>

  <script>
  import axiosIns from '../../../libs/axios'
  import {
    BFormCheckbox, BCard, BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BModal, VBModal,
    BForm, BCardText, BTabs, BTab,
    BImg, BMedia, BCollapse, VBToggle, BListGroup, BListGroupItem, BAvatarGroup, VBTooltip, BFormFile, BFormRadio, BFormDatepicker
  } from 'bootstrap-vue'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import vSelect from 'vue-select'
  import Ripple from 'vue-ripple-directive'
  import Swal from 'sweetalert2'
  import moment from 'moment'
  import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
  import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
  import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
  import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
  import html2canvas from "html2canvas"
  import jsPDF from "jspdf"

  import {
    required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
  } from '@validations'

  export default {
    components: {
      ValidationProvider, ValidationObserver,
      BFormCheckbox, BCard, BTable, BAvatar, BBadge, BRow,
      BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
      BInputGroupAppend, BButton, BModal, VBModal, BForm, BCardText, vSelect, Swal, BTabs, BTab,
      BImg, BMedia, BCollapse, VBToggle, BListGroup, BListGroupItem, BAvatarGroup, VBTooltip, BFormFile, BFormRadio, BFormDatepicker,
      AppTimeline, AppTimelineItem,
      AppCollapse,
      AppCollapseItem
    },
    directives: {
      'b-modal': VBModal,
      Ripple,
      'b-toggle': VBToggle, 'b-tooltip': VBTooltip,
    },
    data() {
      return {
        fecha_creacion_formato_letra: '',
        fecha_actual_formato_letra_pdf: '',
        url_base: '',
        url_logo: '',
        url_firma: '',

        cant_dias: '',
        disabled_cant_dias: false,

        dir: 'ltr',
        fechasUnInvolucrado: [],
        selectedInvolucradoEvento: [],
        optionInvolucradoEvento: [],

        id_sancion: null,
        id_sancion_seteado: '',
        descripcionInvolucradoEvento: '',

        involucrados: [],
        historial_eventos: [],
        matriz_involucrados: [],
        fotos_evidencia: [],

        ultimo_estado_sancion_id: null,
        ultimo_tipo_sancion_id: null,

        titleModalEvento: '',
        titleModalEditarDetalleFalta: '',
        titleModalAddArchivosHistorialEvento: '',
        btnGrabarEvento: '',
        btnEditarDetalleFalta: '',
        btnAddArchivosHistorialEvento: '',
        idInvolucrado: '',
        descripcionEditarDetalleFalta: '',
        observacioninvolucrado: '',
        descripcion: '',
        descripcionStateEvento: '',
        descripcionStateEditarDetalleFalta: '',
        observacioninvolucradoState: '',
        tipoEventoState: '',

        selectedTipoEvento: '1',
        optionsTipoEvento: [],
        tipoEvento: [],

        categoria: null,
        subcategoria: null,

        filesEv: [],
        filesDe: [],

        filesEvAdd: [],
        filesDeAdd: [],

        tipoSancion: [],
        selectedTipoSancion: null,
        optionsTipoSancion: [],

        fechassancioncierre: [],

        sancion: [],
        idHistoriaEventoTemp: null,

        selectedFirmoPapeleta: null,
        optionsFirmoPapeleta: [
          { value: 'SI', text: 'SI' },
          { value: 'NO', text: 'NO' },
        ],


      }
    },
    computed: {

    },
    /*mounted() {
        this.totalRowsCategorias = this.categorias.length;
    },*/
    methods: {
      format_date(value) {
        if (value) {
          return moment(String(value)).format('DD/MM/YYYY')
        }
      },
      format_date_FYH(value) {
        if (value) {
          return moment(String(value)).format('DD/MM/YYYY hh:mm a')
        }
      },
      obtenerTipoSancion() {
        this.optionsTipoSancion = [];
        this.tipoSancion = [];

        const config = {
          method: 'get',
          url: '/sap/md/mdtiposancion/list/',
        };

        axiosIns(config)
            .then((response) => {
              if (response.status === 200) {
                this.tipoSancion = response.data;

                this.tipoSancion.filter((item) => {
                  this.optionsTipoSancion.push({ value: item.id, text: item.descripcion, dias: item.dias });
                });

                //console.log(this.tipoSancion);

              }
              //console.log(JSON.stringify(response.data));
            })
            .catch((error) => {
              //console.log(error);
              console.log("=======error=======ccc");
              this.obtenerTipoSancion();
            });
      },
      obtenerSancion() {
        this.sancion = [];
        this.optionInvolucradoEvento = [];

        var config = {
          method: 'get',
          url: '/sap/md/mdsancion/detalle/' + this.id_sancion
        };

        axiosIns(config).then((response) => {
          //console.log(JSON.stringify(response.data.response));
          if (response.status === 200) {
            //this.involucrados = response.data.response;
            this.sancion = response.data;

            this.fecha_creacion_formato_letra = moment(this.sancion.fecha_creacion).locale('es').format('LL');

            if (this.sancion.empresa === 'AGROVISIÓN PERÚ S.A.C') {
              this.url_logo = this.url_base + '/media/file_medidas/img_pdf/logo_agrovision_negro.png';
              this.url_firma = this.url_base + '/media/file_medidas/img_pdf/firma_agrovision.png';
            } else {
              this.url_logo = this.url_base + '/media/file_medidas/img_pdf/logo_arena_verde_negro.png';
              this.url_firma = this.url_base + '/media/file_medidas/img_pdf/firma_arena_verde.png';
            }

            this.optionInvolucradoEvento = this.sancion.involucrados;

            //console.log(this.sancion);

            this.categoria = response.data.categoria;
            this.subcategoria = response.data.subcategoria;
          }
        }).catch((error) => {
          //console.log(error);
          console.log("=======error=======sdsd");
          this.obtenerSancion();
        });
      },
      /*obtenerInvolucradosXSancion() {
          //this.involucrados = await getInvolucradosXIdSancion(this.id_sancion);
          this.involucrados = [];
          this.optionInvolucradoEvento = [];
          var FormData = require('form-data');
          var data = new FormData();
          data.append('sancion_id', this.id_sancion);

          var config = {
              method: 'post',
              url: '/sap/md/mdinvolucrado/listxsancion/',
              data: data
          };

          axiosIns(config).then((response) => {
              //console.log(JSON.stringify(response.data.response));
              if (response.status === 200) {
                  this.involucrados = response.data.response;
                  //console.log(this.involucrados);
                  this.optionInvolucradoEvento = response.data.response;
              }
          }).catch((error) => {
              //console.log(error);
              console.log("=======error=======www");
              this.obtenerInvolucradosXSancion();
          });
      },*/
      /*obtenerHistorialEventoXSancion() {
          this.historial_eventos = []
          //this.historial_eventos = await getHistorialEventoXIdSancion(this.id_sancion);
          var FormData = require('form-data');
          var data = new FormData();
          data.append('sancion_id', this.id_sancion);

          var config = {
              method: 'post',
              url: '/sap/md/mdhistorialevento/listxsancion/',
              data: data
          };

          axiosIns(config)
              .then((response) => {
                  //console.log(JSON.stringify(response.data.response));
                  if (response.status === 200) {
                      this.historial_eventos = response.data.response;
                      //console.log(this.historial_eventos);
                      //console.log(this.historial_eventos);
                  }
              })
              .catch((error) => {
                  //console.log(error);
                  console.log("=======error=======aaa");
                  this.obtenerHistorialEventoXSancion();
              });
      },*/
      obtenerMatrizInvolucradoXSancion() {
        this.matriz_involucrados = []
        var FormData = require('form-data');
        var data = new FormData();
        data.append('sancion_id', this.id_sancion);

        var config = {
          method: 'post',
          url: '/sap/md/mdmatriz/listxsancion/',
          data: data
        };

        axiosIns(config)
            .then((response) => {
              //console.log(JSON.stringify(response.data.response));
              if (response.status === 200) {
                this.matriz_involucrados = response.data.response;
                //console.log(this.matriz_involucrados);
              }
            })
            .catch((error) => {
              //console.log(error);
              console.log("=======error=======aaa");
              this.obtenerMatrizInvolucradoXSancion();
              return false;
            });
      },
      obtenerMDArchivoXSancion() {
        this.getMDArchivoXSancion(this.id_sancion, "FOTO", "EVIDENCIA");
        //console.log("FOTOOOOOOOOS");
        //console.log(this.fotos_evidencia);
      },
      getMDArchivoXSancion(sancion_id, tipo_archivo, tipo_registro) {

        var FormData = require('form-data');
        var data = new FormData();
        data.append('sancion_id', sancion_id);
        data.append('tipo_archivo', tipo_archivo);
        data.append('tipo_registro', tipo_registro);

        var config = {
          method: 'post',
          url: '/sap/md/mdarchivo/listxsancion/',
          data: data
        };

        axiosIns(config).then((response) => {
          //console.log(JSON.stringify(response.data.response));
          if (response.status === 200) {
            this.fotos_evidencia = response.data.response;
            //console.log(this.fotos_evidencia);
          }
        }).catch((error) => {
          //console.log(error);
          return false;
        });
      },
      mostrarPantallaNuevoEvento() {
        //console.log("soy nueva pantalla");
        //this.categoria = [];
        this.verificarDiasSancion();
        this.titleModalEvento = "Crear Evento";
        this.btnGrabarEvento = "Guardar";

        this.mostrarInvolucradosTipoEvento();
        this.$refs['my-modal-evento'].show();
      },
      retornarVista(){
        this.$router.push('/md/sanciones');
      },
      mostrarPantallaEditarDetalleFalta(idInvolucrado, descripcion, ultimo_estado_sancion_id, ultimo_tipo_sancion_id, observacion_involucrado, firmopapeletainvolucrado) {
        //console.log("soy nueva pantalla");
        //this.categoria = [];
        this.titleModalEditarDetalleFalta = "Editar Detalle Falta";
        this.btnEditarDetalleFalta = "Guardar";

        this.ultimo_estado_sancion_id = ultimo_estado_sancion_id;
        this.ultimo_tipo_sancion_id = ultimo_tipo_sancion_id;

        this.idInvolucrado = idInvolucrado;
        this.descripcionEditarDetalleFalta = descripcion;

        this.observacioninvolucrado = observacion_involucrado;
        this.selectedFirmoPapeleta = firmopapeletainvolucrado;

        this.$refs['my-modal-editar-detalle-falta'].show();
      },
      mostrarPantallaAgregarArchivo(idHistorialEvento) {
        this.idHistoriaEventoTemp = idHistorialEvento;

        this.titleModalAddArchivosHistorialEvento = "Agregar Archivos";
        this.btnAddArchivosHistorialEvento = "Guardar";

        this.$refs['my-modal-subir-archivo-historial-evento'].show();
      },
      zeroFill(number, width) {
        width -= number.toString().length;
        if (width > 0) {
          return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
        }
        return number + ""; // siempre devuelve tipo cadena
      },
      resetModalEvento() {
        this.tipoEventoState = null
        this.descripcionStateEvento = null
      },
      resetModalEditarDetalleFalta() {
        /*this.descripcionEditarDetalleFalta = ''
        this.observacioninvolucrado = ''
        this.selectedFirmoPapeleta = null*/
      },

      resetModalAddArchivosHistorialEvento() {
        this.filesEvAdd = [];
        this.filesDeAdd = [];
      },
      mostrarInvolucradosTipoEvento() {
        const filtersListTipoEvento = this.tipoEvento.filter(element => element.id === this.selectedTipoEvento)
        //const filtersListInvolucradosXTipoEvento = this.involucrados.filter(element => element.ultimo_estado_sancion_id < this.selectedTipoEvento)
        const filtersListInvolucradosXTipoEvento = this.sancion.involucrados.filter(element => element.ultimo_estado_sancion < this.selectedTipoEvento)

        this.selectedInvolucradoEvento = [];
        this.optionInvolucradoEvento = filtersListInvolucradosXTipoEvento;

        //console.log(this.selectedInvolucradoEvento);
      },
      handleOkEvento(bvModalEvt) {

        bvModalEvt.preventDefault()
        this.$refs.simpleRulesEvento.validate().then(success => {
          if (success) {

            this.handleSubmitEvento()
          }
        })
      },
      handleSubmitEvento() {
        //console.log(this.selectedInvolucradoEvento);

        var fechaActual = moment().format('YYYY-MM-DD H:mm:ss');

        this.selectedInvolucradoEvento.forEach((value, index) => {

          var cant_dias_temp = 0;
          var tipo_sancion_temp = 0;

          if (this.selectedTipoEvento !== 5) {
            tipo_sancion_temp = value.ultimo_tipo_sancion;
            cant_dias_temp = value.cant_dias;
          } else {
            tipo_sancion_temp = this.selectedTipoSancion;
            cant_dias_temp = this.cant_dias;
          }



          var FormData = require('form-data');
          var data = new FormData();
          data.append('involucrado_id', value.id);

          var config = {
            method: 'post',
            url: '/sap/md/mdfechasancioninvolucrado/eliminarfechasxinvolucrado/',
            data: data
          };

          axiosIns(config)
              .then((response) => {

                var data = {
                  "sancion": value.sancion,
                  "ultimo_estado_sancion": this.selectedTipoEvento,
                  "ultimo_tipo_sancion": tipo_sancion_temp,
                  "cant_dias": cant_dias_temp,
                  "fecha_actualizacion": fechaActual,
                };

                var config = {
                  method: 'put',
                  url: '/sap/md/mdinvolucrado/editar/' + value.id,
                  data: data
                };

                axiosIns(config)
                    .then((response) => {

                      var data = {
                        "involucrado": value.id,
                        "estado_sancion": this.selectedTipoEvento,
                        "tipo_sancion": tipo_sancion_temp,
                        "cant_dias": cant_dias_temp,
                        "descripcion": this.descripcionInvolucradoEvento,
                        "fecha_creacion": fechaActual,
                        "fecha_actualizacion": fechaActual,
                        "estado": "1"
                      };

                      var config = {
                        method: 'post',
                        url: '/sap/md/mdhistorialevento/crear/',
                        data: data
                      };

                      axiosIns(config)
                          .then((response) => {
                            this.registrarFechasSancion(response.data.id, value.id, fechaActual);
                            this.registrarArchivosEvidencia(response.data.id, value, fechaActual);
                            this.registrarArchivosDescargo(response.data.id, value, fechaActual);

                          })
                          .catch((error) => {
                            //this.errorRegistro("Historial de Evento");
                            this.makeToast('danger', value.nombre_involucrado);
                          });

                    })
                    .catch((error) => {
                      this.errorRegistro("Historial de Evento");
                    }).finally(() => {

                  //this.successRegistro("Historial de Evento");
                  this.makeToast('success', value.nombre_involucrado);

                  this.obtenerSancion();

                  /*this.obtenerInvolucradosXSancion();
                  this.obtenerHistorialEventoXSancion();*/

                });
              })
              .catch((error) => {
                console.log(error);
              });

        })

        this.$nextTick(() => {
          this.$refs['my-modal-evento'].toggle('#toggle-btn')
        })

        /**/
        //this.iniciarFunciones();

      },

      makeToast(variant, involucrado) {
        if (variant === 'success') {
          this.$bvToast.toast('Involucrado: ' + involucrado, {
            title: 'Registro exitoso',
            variant,
            solid: true,
          })
        }

        if (variant === 'danger') {
          this.$bvToast.toast('Involucrado: ' + involucrado, {
            title: 'Registro fallido',
            variant,
            solid: true,
          })
        }

      },
      registrarFechasSancion(idHistorialEvento, idInvolucrado, fechaActual) {

        this.fechassancioncierre.forEach((item, index) => {

          var data = {
            "involucrado": idInvolucrado,
            "nro_dia": item.nro_dia,
            "fecha_sancion": item.fecha_sancion,
            "fecha_creacion": fechaActual,
            "fecha_actualizacion": fechaActual,
            "estado": "1"
          };

          var config = {
            method: 'post',
            url: '/sap/md/mdfechasancioninvolucrado/crear/',
            data: data
          };

          axiosIns(config)
              .then((response) => {
                //console.log(response.data);

              })
              .catch((error) => {
                //this.errorRegistro("Sanción");
              });



        });

      },
      registrarArchivosEvidencia(idHistorialEvento, value, fechaActual) {

        this.filesEv.forEach((item, index) => {

          var FormData = require('form-data');

          var data = new FormData();
          data.append('historial_evento', idHistorialEvento);
          data.append('file', item);
          data.append('tipo_archivo', 'ARCHIVOS');
          data.append('tipo_registro', 'EVIDENCIA');
          data.append('fecha_creacion', fechaActual);
          data.append('estado', '1');

          var config = {
            method: 'post',
            url: '/sap/md/mdarchivo/crear/',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: data
          };

          axiosIns(config)
              .then((response) => {

              })
              .catch((error) => {
                //this.errorRegistro("Historial de Evento");
              });

        });

      },
      registrarArchivosDescargo(idHistorialEvento, value, fechaActual) {

        this.filesDe.forEach((item, index) => {

          var FormData = require('form-data');

          var data = new FormData();
          data.append('historial_evento', idHistorialEvento);
          data.append('file', item);
          data.append('tipo_archivo', 'ARCHIVOS');
          data.append('tipo_registro', 'DESCARGO');
          data.append('fecha_creacion', fechaActual);
          data.append('estado', '1');

          var config = {
            method: 'post',
            url: '/sap/md/mdarchivo/crear/',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: data
          };

          axiosIns(config)
              .then((response) => {

              })
              .catch((error) => {
                //this.errorRegistro("Historial de Evento");
              });

        });

      },
      checkFormValidityEvento() {
        const valid = this.$refs.formEvento.checkValidity()
        this.descripcionStateEvento = valid
        return valid
      },
      handleOkEditarDetalleFalta(bvModalEvt) {
        bvModalEvt.preventDefault()

        this.$refs.simpleRulesEditarDetalleFalta.validate().then(success => {
          if (success) {
            this.handleSubmitEditarDetalleFalta()
          }
        })
      },

      checkFormValidityEditarDetalleFalta() {
        const valid = this.$refs.formEditarDetalleFalta.checkValidity()
        this.descripcionStateEditarDetalleFalta = valid
        return valid
      },
      handleSubmitEditarDetalleFalta() {

        var fechaActual = moment().format('YYYY-MM-DD H:mm:ss');

        const data = {
          "sancion": this.id_sancion,
          "ultimo_estado_sancion": this.ultimo_estado_sancion_id,
          "ultimo_tipo_sancion": this.ultimo_tipo_sancion_id,
          "descripcion": this.descripcionEditarDetalleFalta,
          "observacion_involucrado": this.observacioninvolucrado,
          "firmo_papeleta_involucrado": this.selectedFirmoPapeleta,
          "fecha_actualizacion": fechaActual
        };
        var config = {
          method: 'put',
          url: '/sap/md/mdinvolucrado/editar/' + this.idInvolucrado,
          data: data
        };

        axiosIns(config)
            .then((response) => {
              this.iniciarFunciones();
              this.$nextTick(() => {
                this.$refs['my-modal-editar-detalle-falta'].toggle('#toggle-btn')
              })
              this.successEditado("Detalle de la Falta Cometida");
            })
            .catch((error) => {
              this.errorEditado("Detalle de la Falta Cometida");
            });

      },
      handleOkAddArchivosHistorialEvento(bvModalEvt) {
        bvModalEvt.preventDefault()

        this.$refs.simpleRulesAddArchivosHistorialEvento.validate().then(success => {
          if (success) {
            const cant = this.filesEvAdd.length + this.filesDeAdd.length;
            if (cant !== 0) {
              this.handleSubmitAddArchivosHistorialEvento()
            } else {
              Swal.fire({
                title: 'Advertencia!',
                text: ' Debe registrar Evidencias o Descargos ',
                icon: 'warning',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            }


          }
        })
      },
      checkFormValidityAddArchivosHistorialEvento() {
        const valid = this.$refs.formAddArchivosHistorialEvento.checkValidity()
        this.descripcionStateAddArchivosHistorialEvento = valid
        return valid
      },
      handleSubmitAddArchivosHistorialEvento() {

        if (!this.checkFormValidityAddArchivosHistorialEvento()) {
          return
        }

        var fechaActual = moment().format('YYYY-MM-DD H:mm:ss');

        this.registrarArchivosEvidenciaAdd(this.idHistoriaEventoTemp, fechaActual);
        this.registrarArchivosDescargoAdd(this.idHistoriaEventoTemp, fechaActual);

        this.$nextTick(() => {
          this.$refs['my-modal-subir-archivo-historial-evento'].toggle('#toggle-btn')
        })

        this.successRegistro("Historial de Evento");

      },

      registrarArchivosEvidenciaAdd(idHistorialEvento, fechaActual) {

        this.filesEvAdd.forEach((item, index) => {

          var FormData = require('form-data');

          var data = new FormData();
          data.append('historial_evento', idHistorialEvento);
          data.append('file', item);
          data.append('tipo_archivo', 'ARCHIVOS');
          data.append('tipo_registro', 'EVIDENCIA');
          data.append('fecha_creacion', fechaActual);
          data.append('estado', '1');

          var config = {
            method: 'post',
            url: '/sap/md/mdarchivo/crear/',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: data
          };

          axiosIns(config)
              .then((response) => {
                this.iniciarFunciones();
              })
              .catch((error) => {
                this.errorRegistro("Historial de Evento");
              });

        });

      },
      registrarArchivosDescargoAdd(idHistorialEvento, fechaActual) {

        this.filesDeAdd.forEach((item, index) => {

          var FormData = require('form-data');

          var data = new FormData();
          data.append('historial_evento', idHistorialEvento);
          data.append('file', item);
          data.append('tipo_archivo', 'ARCHIVOS');
          data.append('tipo_registro', 'DESCARGO');
          data.append('fecha_creacion', fechaActual);
          data.append('estado', '1');

          var config = {
            method: 'post',
            url: '/sap/md/mdarchivo/crear/',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: data
          };

          axiosIns(config)
              .then((response) => {
                this.iniciarFunciones();
              })
              .catch((error) => {
                this.errorRegistro("Historial de Evento");
              });

        });

      },
      obtenerEstados() {
        this.tipoEvento = [];
        this.optionsTipoEvento = [];
        const arrayEstado = [];

        var config = {
          method: 'get',
          url: '/sap/md/mdestadosancion/list/',
        };

        axiosIns(config).then((response) => {

          if (response.status === 200) {
            this.tipoEvento = response.data;
            let optionsTemporal = response.data;

            optionsTemporal.filter((item) => {
              arrayEstado.push({ value: item.id, text: item.descripcion });
            });

            this.optionsTipoEvento = arrayEstado;

          }

        }).catch((error) => {
          //console.log(error);
          console.log("=======error=======bbb");
          this.obtenerEstados();
        });
      },
      successRegistro(texto) {
        Swal.fire({
          title: 'Registro exitoso!',
          text: texto + ' se registro de manera satisfactoria!',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        });
      },
      errorRegistro(texto) {
        Swal.fire({
          title: 'Error!',
          text: texto + ' no se registro!',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      },
      successEditado(texto) {
        Swal.fire({
          title: 'Modificación exitoso!',
          text: texto + ' se modificó de manera satisfactoria!',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        });
      },
      errorEditado(texto) {
        Swal.fire({
          title: 'Error!',
          text: texto + ' no se modificó!',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      },
      verificarDiasSancion() {
        this.fechassancioncierre = [];
        this.cant_dias = 0;
        this.disabled_cant_dias = true;

        this.tipoSancion.filter((item) => {
          if (item.id === this.selectedTipoSancion) {

            if (item.dias === "NO") {
              this.cant_dias = 0;
              this.disabled_cant_dias = true;
            }
            if (item.dias === "SI") {
              this.cant_dias = "";
              this.disabled_cant_dias = false;
            }
          }
        });

      },
      calcularFechasSancionCierre() {
        //tipo:  0 => automatico, 1 => manual

        this.fechassancioncierre = [];

        const tipo = 0;

        var fechaInicialST = moment().add({ days: 0 }).format('YYYY-MM-DD');

        var inputFecha = "";

        var diasSuma = 0;

        var nroweekday = 11111;

        for (var i = 0; i < this.cant_dias - tipo; i++) {

          diasSuma = 1;
          nroweekday = 11111;

          const fechaInvo = this.fechasUnInvolucrado.filter(element => Number(element.nro_dia) === i);

          if(fechaInvo.length !== 0){
            fechaInicialST = fechaInvo[0].fecha_sancion;
          }else{
            while (nroweekday === 11111 || nroweekday === 0) {

              var fechaActualD = fechaInicialST;

              var fechaTemp = moment(fechaActualD).add({ days: diasSuma });

              nroweekday = fechaTemp.get('weekday');
              fechaActualD = fechaTemp.format('YYYY-MM-DD');

              inputFecha = fechaActualD;

              fechaInicialST = inputFecha;

            }
          }

          console.log(fechaInicialST);

          this.fechassancioncierre.push({
            involucrado: '',
            dni_involucrado: '',
            nro_dia: i,
            fecha_sancion: fechaInicialST,
            fecha_creacion: '',
            fecha_actualizacion: '',
            estado: '1'
          });

        }

        //console.log(this.fechassancioncierre);
      },
      generarMemorandum(dni, fecha_creacion) {
        fecha_creacion = fecha_creacion.replace('-', '');
        fecha_creacion = fecha_creacion.replace('-', '');

        window.html2canvas = html2canvas
        var doc = new jsPDF("p", "pt", "a4")

        doc.html(document.querySelector("#testHtml" + dni), {
          callback: function (pdf) {
            pdf.save(dni + ".pdf")
            //doc.output('dataurlnewwindow',{filename: 'PDF Generado'});
          }
        });

      },
      generarMemorandumV2(dni, fecha_creacion) {
        fecha_creacion = fecha_creacion.replace('-', '');
        fecha_creacion = fecha_creacion.replace('-', '');

        window.html2canvas = html2canvas
        var doc = new jsPDF("p", "pt", "a4")

        doc.html(document.querySelector("#testHtmlV2" + dni), {
          callback: function (pdf) {
            pdf.save(dni + ".pdf")
            //doc.output('dataurlnewwindow',{filename: 'PDF Generado'});
          }
        });

      },
      mostrarColorEstadoSancion(idEstadoSancion){
        const filtersList = this.tipoEvento.filter(element => element.id === idEstadoSancion)
        return(filtersList[0].color);
      },
      mostrarDescripcionEstadoSancion(idEstadoSancion){
        const filtersList = this.tipoEvento.filter(element => element.id === idEstadoSancion)
        return(filtersList[0].descripcion);
      },
      mostrarDescripcionTipoSancion(idTipoSancion, dni){

        this.fechasUnInvolucrado = [];


        if(this.sancion.length !== 0){
          const fechasSancion = this.sancion.involucrados.filter(element => element.dni_involucrado === dni);

          if(fechasSancion[0].fechas_sancion.length !== 0){
            const fechasSancionFinales = fechasSancion[0].fechas_sancion.filter(element => element.estado === "1");

            this.fechasUnInvolucrado = fechasSancionFinales;
          }
        }

        const filtersList = this.tipoSancion.filter(element => element.id === idTipoSancion)
        return(filtersList[0].descripcion);
      },
      iniciarFunciones() {




        this.obtenerSancion();
        //this.obtenerInvolucradosXSancion();
        //this.obtenerHistorialEventoXSancion();
        this.obtenerMatrizInvolucradoXSancion();
        //this.obtenerMDArchivoXSancion();


      },
      mostrar_fechas(fechas){
        const valorEncontrado = fechas.filter((item) => item.estado === '1');
        var arrayOrdenado = valorEncontrado.sort((a, b) => new Date(a["fecha_sancion"]).valueOf() - new Date(b["fecha_sancion"]).valueOf());
        var cadena_fechas = "";
        for (let i = 0; i < arrayOrdenado.length; i++) {
          if(i < arrayOrdenado.length-1){
            cadena_fechas = cadena_fechas + arrayOrdenado[i].fecha_sancion + ", ";
          }else{
            cadena_fechas = cadena_fechas + arrayOrdenado[i].fecha_sancion;
          }
        }

        return cadena_fechas;
      },

      fechaEspañol(fecha){
        return moment(fecha).locale('es').format('LL')
      }

    },
    created() {
      this.id_sancion = this.$route.params.id_sancion;
      this.id_sancion_seteado = this.zeroFill(this.$route.params.id_sancion, 5);
      this.fecha_actual_formato_letra_pdf = moment().locale('es').format('LL');
      //this.url_base = 'http://localhost:7000';
      this.url_base = 'https://www.agvperu.com/backend';
      this.obtenerEstados();
      this.obtenerTipoSancion()
      this.iniciarFunciones();
    },
  }
  </script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .b-table-selectable {
    .feather {
      font-size: 1.3rem;
    }
  }

  .centrado {
    text-align: center;
    //border: 1px dotted #000;
  }

  .centradosubrayado {
    text-align: center;
    font-weight: bold;
    //border: 1px dotted #000;
  }

  .left {
    text-align: left;
  }

  .right {
    text-align: right;
  }

  .justify {
    text-align: justify;
  }

  .textopequenioV1 {
    font-size: 8px;
  ;
  }

  .textopequenio {
    font-size: 9px;
  ;
  }
  </style>
